import React, {useEffect} from 'react';
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";
import iconLocation from "../../../assets/img/hubungi-kami/map-pin.svg"

export default function Content() {
    useEffect(() => {
        const isMobile = window.innerWidth <= 540;
        const initialCenter = isMobile
            ? [-6.22814575, 106.80710720]
            : [-6.227948696671188, 106.8062666545336];
        const zoom = isMobile ? 17 : 18;
        const map = L.map("map", {
            scrollWheelZoom: false,
            dragging: !isMobile
        }).setView(initialCenter, zoom);

        // const map = L.map("map").setView([-6.227948696671188, 106.8062666545336], 17);

        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap",
        }).addTo(map);

        const markers = [
            { position: [-6.22814575, 106.80710720], popup: "Head Office" },
            { position: [-6.227948696671188, 106.8062666545336], popup: "Office" }
        ];

        markers.forEach(({ position, popup }) => {
            L.marker(position, {
                icon: L.icon({
                    iconUrl: markerIconPng,
                    shadowUrl: markerShadowPng,
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                }),
            }).bindPopup(popup).addTo(map);
        });

        setTimeout(() => {
            const yOffset = isMobile ? 80 : 0;
            map.panBy([0, yOffset]);
        }, 300);

        return () => {
            map.remove();
        };
    }, []);

    return (
        <div className="hubungi-kami-map">
            <div id="map">
                <div
                    className="map-info space-y-5"
                    style={{zIndex: "1000"}}>
                    <h4 className="row-title">Lokasi Kami</h4>
                    <div className={"flex flex-col head-office"}>
                        <a className="flex flex-row space-x-2 items-start" href="https://maps.app.goo.gl/fqGVqwgwMWQDqvUT7" target="_blank" rel="noreferrer">
                            <img src={iconLocation} alt="loc-icon"/>
                            <div className={"inner-info"}>
                                <p className="title-info m-0">Head Office</p>
                                <p className="mb-4">Prosperity Tower Lantai 20 Unit G District 8, SCBD Lot 28<br/>
                                    Jl. Jend Sudirman kav 52-53 Jakarta 12190</p>
                            </div>
                        </a>
                    </div>
                    <div className={"flex flex-col"}>
                        <a className="flex flex-row space-x-2 items-start" href="https://maps.app.goo.gl/MPjPHKtANct49oSK7" target="_blank" rel="noreferrer">
                            <img src={iconLocation} alt="loc-icon"/>
                            <div className={"inner-info"}>
                                <p className="title-info m-0">Office</p>
                                <p className="mb-4">Treasury Tower Lantai 9 Unit I District 8, SCBD Lot 28 <br/>
                                    Jl. Jend Sudirman kav 52-53 Jakarta 12190</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    )
}